<template lang="pug">
.waiter-template-select-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：様式名
    template(#cell(templateName)="row")
      b-form-radio(v-model="_selectValue" :name="radioName" :value="row.item.id" v-validate="{ required: true }" data-vv-as="様式") {{ row.item.name }}
    // セル：内容
    template(#cell(preview)="row")
      button.btn.preview-btn(@click="onPreview(row.item)" type="button") プレビュー
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { Template as ApplicationTemplate } from "@/commons/services/AdmissionApplicationTemplates";
import { Template as JudgementTemplate } from "@/commons/services/AdmissionJudgementTemplates";

/**
 * ### テンプレート選択テーブルコンポーネント
 */
@Component({})
export default class TemplateSelectTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<TemplateSelectTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<TemplateSelectTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  /** 選択させるテンプレート */
  @Prop({ required: true })
  selectValue!: string;
  /** 選択肢のname属性 */
  @Prop({ required: true })
  radioName!: string;

  get _value(): Array<TemplateSelectTableItem> {
    return this.value;
  }

  get _selectValue(): string {
    return this.selectValue;
  }

  set _selectValue(newValue: string) {
    this.$emit("update:selectValue", newValue);
    return;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: TemplateSelectTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  public filterSearchWords(row: TemplateSelectTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundTemplateName: boolean = false;

    for (const word of words) {
      if (row.name.indexOf(word) != -1) {
        foundTemplateName = true;
        break;
      }
    }

    return foundTemplateName;
  }

  /**
   * ### プレビューボタン押下イベント
   */
  public onPreview(item: TemplateSelectTableItem): void {
    this.$emit("onPreview", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface TemplateSelectTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface TemplateSelectTableItem {
  /** システムで一意に特定するための ID */
  id: string;
  /** テンプレート名 */
  name: string;
  /** テンプレート説明 */
  information: string;
  /** 最初の要素かどうか、バリデーションで使用する */
  isFirst: boolean;
  /** テンプレート情報の Object */
  template: ApplicationTemplate | JudgementTemplate;
}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.waiter-progress-histories-table-component {
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .progress-history-icon {
    @include svg-icon("../../../assets/waiter/progress-history.svg", $font-base-color, 24px, 24px);
  }
  .update-history-icon {
    @include svg-icon("../../../assets/waiter/update-history.svg", $font-base-color, 24px, 24px);
  }
}
</style>
